import React from 'react';

import { UserContextProvider } from './user';
import { AnalyticsContextProvider } from './analytics';
import { AccreditationContextProvider } from './accreditation';
import {FacebookPixelContextProvider, TiktokPixelContextProvider, GoogleAdsContextProvider} from "./tracking/declarations";

const GlobalContext: React.FC = ({ children }) => {
    return (
        <>
            <UserContextProvider>
				<AnalyticsContextProvider>
					<GoogleAdsContextProvider>
						<FacebookPixelContextProvider>
							<TiktokPixelContextProvider>
								<AccreditationContextProvider>
									{ children }
								</AccreditationContextProvider>
							</TiktokPixelContextProvider>
						</FacebookPixelContextProvider>
					</GoogleAdsContextProvider>
				</AnalyticsContextProvider>
			</UserContextProvider>
        </>
    )
}

export default GlobalContext;
